import { useEffect, useState } from "react";

import {
  Modal,
  Button,
  Input,
  Select,
  DatePicker,
  InputNumber,
  message,
} from "antd";
const { TextArea } = Input;
const { Option } = Select;

import dayjs from "dayjs";
import { API, URL } from "../../config/api";

const ModalAddInhouse = ({
  visible,
  onClose,
  title,
  content,
  onSave,
  submitText = "Submit",
  showFooter = true,
  readOnly = false,
  getData,
}) => {
  const [tanggal, setTanggal] = useState(null);

  const [formData, setFormData] = useState([
    {
      accountId: null,
      kategori: null,
      amount: null,
      keterangan: "",
    },
  ]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (index, field, value) => {
    const newData = [...formData];
    newData[index][field] = value;
    setFormData(newData);
  };

  const addRow = () => {
    setFormData([
      ...formData,
      {
        accountId: null,
        kategori: null,
        amount: null,
        keterangan: "",
      },
    ]);
  };

  const removeRow = (index) => {
    const newData = formData.filter((_, i) => i !== index);
    setFormData(newData);
  };

  const validationFormTransaction = (trx) => {
    const hasDebit = trx.some((tr) => tr.kategori === "debit");
    const hasKredit = trx.some((tr) => tr.kategori === "kredit");

    if (!hasDebit || !hasKredit) {
      return {
        valid: false,
        message: "Data harus mengandung minimal 1 debit dan 1 kredit",
      };
    }

    const totalDebit = trx
      .filter((tr) => tr.kategori === "debit")
      .reduce((sum, tx) => sum + tx.amount, 0);

    const totalKredit = trx
      .filter((tr) => tr.kategori === "kredit")
      .reduce((sum, tr) => sum + tr.amount, 0);

    if (totalDebit !== totalKredit) {
      return {
        valid: false,
        message: `Total debit ${totalDebit} dan kredit ${totalKredit} harus sama`,
      };
    }

    return { valid: true };
  };

  const handleOk = async (e) => {
    e.preventDefault(); // Mencegah form submit otomatis
    const updatedFormData = formData.map((item) => ({
      ...item,
      tgl: dayjs(tanggal).format("YYYY-MM-DD"), // Format YYYY-MM-DD
    }));

    // console.log("updatedFormData e ====>", updatedFormData);
    // handleSubmit(updatedFormData);

    const validationResult = validationFormTransaction(updatedFormData);

    try {
      if (!validationResult.valid) {
        message.error(`${validationResult.message}`);
      } else {
        await API.post(URL.TRX_INHOUSE + "/add", updatedFormData);

        message.success("Success create data");
        onSave();
      }
      visible = null;
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Gagal menambahkan data!");
      visible = null;
      closeModal();
    }
  };

  const closeModal = () => {
    setFormData([
      { accountId: null, kategori: null, amount: null, keterangan: "" },
    ]);
    setTanggal(null);
    onClose();
  };

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const res = await API.get(URL.MASTER_ACC);
        const data = res.data.data;

        // Transformasi data agar sesuai format options Select
        const formattedOptions = data.map((item) => ({
          value: item.id,
          label: `${item.noAcc} - ${item.nameAcc}`,
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  // console.log(options);

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={closeModal}
      footer={
        showFooter && (
          <>
            <Button onClick={closeModal}>Cancel</Button>

            <Button type="primary" htmlType="submit" form="custom-modal-form">
              {submitText}
            </Button>
          </>
        )
      }
      width={1000}
      style={{
        top: 20,
      }}
    >
      <form id="custom-modal-form" onSubmit={handleOk}>
        {/* {content} */}
        <div>
          <label>
            Tanggal : <span className="text-red-500">*</span>
          </label>{" "}
          <br />
          <DatePicker
            name="tgl"
            value={tanggal}
            onChange={(date) => setTanggal(date)}
            placeholder="Tanggal"
            size="large"
            className="mt-1"
            format={dayjs().format("YYYY-MM-DD")}
            required
          />
        </div>

        <div>
          <ul>
            {formData.map((item, index) => (
              <div key={index} className="flex gap-2 items-center">
                <li className="grid grid-cols-4 gap-2 w-full items-start p-2 rounded-lg my-2 border border-gray-300">
                  <div>
                    <label>
                      Pilih Akun : <span className="text-red-500">*</span>
                    </label>
                    <br />
                    <Select
                      className="w-full"
                      size="middle"
                      loading={loading}
                      showSearch
                      allowClear
                      placeholder="pilih Akun"
                      value={item.accountId}
                      onChange={(value) =>
                        handleChange(index, "accountId", value)
                      }
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={options}
                      required
                    />
                  </div>

                  <div>
                    <label>
                      Pilih Kategori : <span className="text-red-500">*</span>
                    </label>
                    <br />
                    <Select
                      className="w-full"
                      size="middle"
                      // loading={loading}
                      showSearch
                      allowClear
                      placeholder="pilih kategori"
                      value={item.kategori}
                      onChange={(value) =>
                        handleChange(index, "kategori", value)
                      }
                      required
                    >
                      <Option value="debit">Debit</Option>
                      <Option value="kredit">Kredit</Option>
                    </Select>
                  </div>

                  <div>
                    <label>
                      Amount : <span className="text-red-500">*</span>
                    </label>
                    <br />
                    <InputNumber
                      name="amount"
                      value={item && item?.amount}
                      onChange={(value) => handleChange(index, "amount", value)}
                      placeholder="Amount"
                      size="middle"
                      className="w-full"
                      controls={false}
                      // min={0}
                      disabled={item?.kategori == null}
                      required
                      // formatter={(value) =>
                      //   `${value}.00`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      // }
                      // parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                      formatter={(value) =>
                        value
                          ? new Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(value)
                          : ""
                      }
                      parser={(value) =>
                        parseFloat(value.replace(/,/g, "")) || 0
                      }
                    />
                  </div>

                  <div>
                    <label>
                      Keterangan : <span className="text-red-500">*</span>
                    </label>
                    <TextArea
                      name="keterangan"
                      value={item && item?.keterangan}
                      onChange={(e) =>
                        handleChange(index, "keterangan", e.target.value)
                      }
                      // rows={3}
                      placeholder="Keterangan"
                      size="middle"
                      required
                    />
                  </div>
                </li>
                <Button
                  onClick={() => removeRow(index)}
                  disabled={formData.length === 1}
                >
                  ❌
                </Button>
              </div>
            ))}
          </ul>
        </div>
        <Button onClick={addRow}>➕ Tambah Data</Button>
      </form>
    </Modal>
  );
};

export default ModalAddInhouse;
